import {
  Component,
  Injectable,
  Input,
  Output,
  EventEmitter,
  OnInit,
} from '@angular/core';
import {
  NgbDateParserFormatter,
  NgbDateStruct,
} from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct {
    if (value) {
      const dateParts = value.trim().split('/');
      if (dateParts.length === 1 && +dateParts[0]) {
        return { day: +dateParts[0], month: null, year: null };
      } else if (dateParts.length === 2 && +dateParts[0] && +dateParts[1]) {
        return { day: +dateParts[0], month: +dateParts[1], year: null };
      } else if (
        dateParts.length === 3 &&
        +dateParts[0] &&
        +dateParts[1] &&
        +dateParts[2]
      ) {
        return {
          day: +dateParts[0],
          month: +dateParts[1],
          year: +dateParts[2],
        };
      }
    }
    return null;
  }

  format(date: NgbDateStruct): string {
    return date ? `${date.day.toString().padStart(2, "0")}/${date.month.toString().padStart(2, "0")}/${date.year}` : '';
  }
}

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss'],
  providers: [
    { provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter },
  ],
})
export class DatepickerComponent implements OnInit {
  private _date: SimpleDate;
  public get internalDate(): SimpleDate {
    return this._date;
  }
  public set internalDate(value: SimpleDate) {
    this._date = value;
    this.ChangeDate(this._date);
  }

  public id: string;

  @Input() label: string;
  @Input() inline: boolean;
  @Input() small: boolean;
  @Input() simple: boolean;
  @Input() required: boolean;
  @Input() minDate?: NgbDateStruct;
  @Input() maxDate?: NgbDateStruct;
  @Input() disabled: boolean = false;
  @Input() addReset: boolean = false;
  @Input() marginBottom: boolean = true;
  @Input() simpleLabelWidth?: number = null;
  @Input() set date(value: Date) {
    this.setInternalDate(value);
  }
  @Output() dateChange: EventEmitter<Date> = new EventEmitter<Date>();
  @Output() resetFilter: EventEmitter<Boolean> = new EventEmitter<Boolean>();

  ngOnInit(): void {
    this.id = this.makeId(7);
  }

  public ChangeDate(newDate: SimpleDate): void {
    if (newDate) {
      if (typeof (newDate) == "string") {
        const splitDate = (newDate as string).split("/");
        if (splitDate[2] && splitDate[2].length == 4) {
          newDate = { day: +splitDate[0], month: +splitDate[1], year: +splitDate[2] }
        }
      }
      const newFullDate: Date = new Date();
      newFullDate.setDate(1);
      newFullDate.setFullYear(newDate.year);
      newFullDate.setMonth(newDate.month - 1);
      newFullDate.setDate(newDate.day);
      if (newFullDate.getUTCDate()) {
        this.dateChange.emit(newFullDate);
      } else {
        this.dateChange.emit(null);
      }
    } else {
      this.dateChange.emit(null);
    }
  }

  public ResetFilter(): void {
    this.resetFilter.emit(true);
  }

  private setInternalDate(value: Date): void {
    if (value == null) {
      this._date = null;
    } else {
      if (typeof (value.getMonth) != 'function') {
        value = new Date(value);
      }

      if (value instanceof Date && !isNaN(<any>value)) {
        this._date = {
          year: value.getFullYear(),
          month: value.getMonth() + 1,
          day: value.getDate(),
        };
      } else {
        this._date = null;
      }
    }
  }

  private makeId(length) {
    var result = [];
    var characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result.push(
        characters.charAt(Math.floor(Math.random() * charactersLength))
      );
    }
    return result.join('');
  }
}

interface SimpleDate {
  year: number;
  month: number;
  day: number;
}
